import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append("email", email);
      await fetch("https://readdy.ai/api/form/d7dc97nsch5bvrijffl0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left */}
          <div>
            <img
              src="https://static.readdy.ai/image/751042991eee80e3d0f5ce87d83ca658/78871cc3cb98add911b4c909beefd628.png"
              alt="HipoBuy 2026"
              className="h-10 w-auto object-contain mb-4"
            />
            <h2 className="text-2xl md:text-3xl font-bold mb-3 leading-snug">
              Stay Connected with<br />HipoBuy 2026
            </h2>
            <p className="text-stone-400 text-sm mb-6 leading-relaxed">
              Subscribe to our newsletter for exclusive deals, new arrivals, and HipoBuy shopping tips delivered straight to your inbox.
            </p>
            {submitted ? (
              <div className="flex items-center gap-2 text-amber-400 text-sm font-medium">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-lg"></i>
                </div>
                Thanks for subscribing! Welcome to HipoBuy 2026.
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="flex-1 bg-stone-800 border border-stone-700 rounded-full px-4 py-2.5 text-sm text-white placeholder-stone-500 focus:outline-none focus:border-amber-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {submitting ? "Subscribing..." : "Subscribe"}
                </button>
              </form>
            )}

            <div className="flex items-center gap-4 mt-8">
              <a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-stone-800 rounded-full hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-stone-800 rounded-full hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-stone-800 rounded-full hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-sm"></i>
              </a>
              <a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-stone-800 rounded-full hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Quick Links</h3>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Home</Link></li>
                <li><a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Main Store</a></li>
                <li><Link to="/#articles" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Articles</Link></li>
                <li><Link to="/#faq" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">FAQ</Link></li>
                <li><a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">HipoBuy Shipping</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Categories</h3>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Support</h3>
              <ul className="space-y-2.5">
                <li><Link to="/hipobuy-shipping-explained" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Shipping Info</Link></li>
                <li><Link to="/return-refund-policy" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Returns</Link></li>
                <li><Link to="/payment-security-guide" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Payment Security</Link></li>
                <li><Link to="/first-time-buyer-guide" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">Buyer Guide</Link></li>
                <li><Link to="/#faq" className="text-stone-400 text-sm hover:text-white transition-colors cursor-pointer">FAQ</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            &copy; 2026 HipoBuy 2026 (hipobuy2026.net). All rights reserved.
          </p>
          <p className="text-stone-500 text-xs">
            Powered by{" "}
            <a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-amber-500 hover:text-amber-400 cursor-pointer">
              repsw2c.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
